export default __webpack_public_path__ + "static/media/exif.83f7b49a.svg";